export default __webpack_public_path__ + "static/upkeep-logo-color-dark-aaa389580e5a27edc4a8e16ede824154.svg";